"use client";
import React from "react";

const overlayClasses = [
	"ReactModal__Overlay",
	"ReactModal__Overlay--after-open",
	"fixed w-screen h-screen inset-0",
	"bg-black bg-opacity-75",
	"z-50",
].join(" ");

export const ModalOverlay = () => (
	<div aria-hidden="true" className={overlayClasses}></div>
);
